// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-width[data-v-7652c2d0]{width:320px}.card[data-v-7652c2d0]{cursor:default;border-radius:.6rem}\n", ""]);
// Exports
module.exports = exports;
